import {
  SiteAlarmType,
  AllSitesAlarmType,
} from '../../../features/alarms/alarmsAPI';
import { isSiteAlarmType } from '../../../features/alarms/alarmsAPI';

const fillInGraphingUrl = (
  siteId: number,
  encodedSiteNameAndLocation: string,
  encodedControllerName: string,
  encodedApplication: string,
) => {
  return `/site/${siteId}/${encodedSiteNameAndLocation}/controller/${encodedControllerName}/graph/${encodedApplication}`;
};

const getPropertiesBasedOnAlarmType = (
  row: SiteAlarmType | AllSitesAlarmType,
  siteId: number,
  encodedControllerName: string,
  encodedApplication: string,
) => {
  if (!isSiteAlarmType(row)) {
    const encodedSiteNameAndLocation = encodeURIComponent(
      `${row.siteName} - ${row.siteLocation}`,
    );
    return fillInGraphingUrl(
      siteId,
      encodedSiteNameAndLocation,
      encodedControllerName,
      encodedApplication,
    );
  } else {
    const encodedSiteNameAndLocation = encodeURIComponent(
      row.siteNameAndLocation,
    );
    return fillInGraphingUrl(
      siteId,
      encodedSiteNameAndLocation,
      encodedControllerName,
      encodedApplication,
    );
  }
};

const buildGraphingUrl = (
  value: string,
  row: SiteAlarmType | AllSitesAlarmType,
) => {
  const encodedControllerName = encodeURIComponent(row.controller_name);
  const siteId = row.siteId;
  if (value.includes(':')) {
    const colonCount = value.split('').filter((s) => s === ':').length;

    if (colonCount === 2) {
      const [_controller, application] = value.split(':');
      const encodedApplication = encodeURIComponent(application);
      return getPropertiesBasedOnAlarmType(
        row,
        siteId,
        encodedControllerName,
        encodedApplication,
      );
    } else {
      const [application] = value.split(':');
      const encodedApplication = encodeURIComponent(application);
      return getPropertiesBasedOnAlarmType(
        row,
        siteId,
        encodedControllerName,
        encodedApplication,
      );
    }
  } else {
    const application = value;
    const encodedApplication = encodeURIComponent(application);
    return getPropertiesBasedOnAlarmType(
      row,
      siteId,
      encodedControllerName,
      encodedApplication,
    );
  }
};

export default buildGraphingUrl;
